export type TimeParts = {
  hour: number;
  minute: number;
};

export function timeToParts(value: string | null | undefined): TimeParts | null {
  if (!value) return null;

  const match = value.match(/^(\d{1,2}):(\d{1,2})/);
  if (!match) return null;

  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (Number.isNaN(hour) || Number.isNaN(minute)) return null;

  return { hour, minute };
}

export function partsToTime(
  hour: number | null,
  minute: number | null,
  options: { withSeconds?: boolean } = {}
): string | null {
  if (hour == null || minute == null) return null;
  if (Number.isNaN(hour) || Number.isNaN(minute)) return null;

  const time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
  return options.withSeconds ? `${time}:00` : time;
}
